module.exports = __webpack_public_path__ + "static/media/money-pounds-one.7182b312.svg";